import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';

import FormRichEditor from 'components/forms/FormRichEditor';
import FormErrors from 'components/forms/FormErrors';

class LeadDeleteForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deletionReason: '',
    };
  }

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    const { lead, onSubmit } = this.props;
    const { deletionReason } = this.state;
    onSubmit(lead.id ? lead.id : lead.getId(), { deletionReason });
  };

  render() {
    const {
      intl: { messages },
      onSubmitParent,
      formStatus,
    } = this.props;
    const { deletionReason } = this.state;

    return (
      <div>
        <FormErrors formStatus={formStatus} />

        <form type="post" onSubmit={this.onSubmit}>
          <div class="panel panel-transparent">
            <div class="form-group-attached">
              <FormRichEditor
                label={messages.delete_reason}
                name="lostReason"
                value={deletionReason}
                onChange={(name, deletionReason) => this.setState({ deletionReason })}
                disabled={formStatus.pending}
              />
            </div>
          </div>

          <div class="text-right m-t-15">
            <Button
              bsSize="lg"
              disabled={formStatus.pending}
              type="submit"
              bsStyle={deletionReason !== '' ? 'primary' : 'default'}
            >
              <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
              {messages.save}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.leadDelete,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (leadId, args) => {
      formStatusDispatchHelper('leadDelete', `/api/leads/${leadId}/delete.json`, args, 'post', dispatch);
    },
    onFormSuccessfull: () => {
      dispatch(formReset('leadDelete'));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadDeleteForm)
  )
);
